angular.module('filters', ['filters.propsFilter',
                           'filters.multiPartFilter'
]);
